<template>
  <div>
    <base-card>
      <div>
        <v-card-title v-if="!cardLoading" class="mb-n7">
          <v-row>
            <v-col class="d-flex justify-space-between flex-wrap align-center">
              <div>
                <v-btn
                  class="ma-2 mb-6"
                  small
                  dark
                  color="primary"
                  @click="(title = 'Add'), openDialog()"
                >
                  <v-icon small>mdi-plus</v-icon>
                  Assign Branch Ingredient
                </v-btn>
                <v-btn
                  class="ma-2 mb-6"
                  small
                  dark
                  :loading="multiBtnLoading"
                  color="danger"
                  v-if="selected != ''"
                  @click="dialogDelete = true"
                >
                  <v-icon small>mdi-delete</v-icon>
                  delete
                </v-btn>
              </div>

              <div style="width: 250px">
                <v-select
                  v-model="selectBranch"
                  :items="branchList"
                  item-text="name"
                  item-value="branch_id"
                  solo
                  dense
                ></v-select>
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-title>
          <v-row>
            <v-col cols="12" lg="8">Branch Ingredient</v-col>
            <v-col cols="12" lg="4"
              ><v-text-field
                class="mt-n5"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                v-if="!cardLoading"
              ></v-text-field
            ></v-col>
          </v-row>
        </v-card-title>
        <div class="text-center" v-if="cardLoading">
          <v-progress-circular
            class="mb-16"
            :size="40"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <div v-show="!cardLoading">
          <v-data-table
            v-model="selected"
            :search="search"
            :headers="headers"
            :items="branchIngredientList"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            item-key="ingredient_company_id"
            @click:row="handleClick"
            show-select
          >
          </v-data-table>
        </div>
      </div>
    </base-card>

    <v-dialog v-model="dialog" width="600">
      <base-card>
        <v-card-text>
          <div class="mb-5">
            <span class="text-h6" v-if="title == 'Add'">
              Assign Branch Ingredient
            </span>
            <span class="text-h6" v-if="title == 'Edit'"> Edit</span>
          </div>
          <v-autocomplete
            v-model="selectedIngredient"
            :items="ingredientList"
            label="Select Ingredient"
            clearable
            :error-messages="selectedIngredientErrors"
            required
            @input="$v.selectedIngredient.$touch()"
            @blur="$v.selectedIngredient.$touch()"
            dense
            outlined
            item-text="name"
            item-value="ingredient_company_id"
            :disabled="title == 'Add' ? false : true"
          ></v-autocomplete>

          <v-data-table
            v-if="selectedIngredient"
            v-model="selectedBranchIngredient"
            :headers="branchHeaders"
            :items="branchIngredient"
            item-key="id"
            class="elevation-2 mt-4"
            :show-select="title == 'Add' ? true : false"
          >
            <template v-slot:item.branch="{ item }">
              {{ item.name }}
            </template>

            <template v-slot:item.stock="{ item }">
              <div class="stock-cell mb-1" v-if="isSelected(item.id)">
                <v-text-field
                  v-model="item.stock"
                  type="number"
                  dense
                  outlined
                  hide-details
                  placeholder="Enter stock"
                  class="stock-field"
                ></v-text-field>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            :loading="singleBtnLoading"
            v-if="title == 'Edit'"
            @click="dialogDelete = true"
            text
            icon
            color="red lighten-2"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="dialogAction()"
            :loading="saveBtnLoading"
            text
          >
            save
          </v-btn>
        </v-card-actions>
      </base-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card>
        <v-card-title class="text-subtitle-1"
          >Are you sure to delete this ingredient? Branch ingredient and
          ingredient movement will be delete.</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" @click="deleteIngredient" text>OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { BASEURL, BASESYNCURL } from "@/api/baseurl";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    selectedIngredient: { required },
  },
  data() {
    return {
      domain: BASEURL,
      syncDomain: BASESYNCURL,
      branchList: [],
      snackbar: false,
      text: "",
      snackbarColor: "",
      timeout: 1900,
      companyID: "",
      branchHeaders: [
        { text: "Branch Name", sortable: false, value: "branch" },
        { text: "Stock", sortable: false, value: "stock" },
      ],
      branchIngredient: [],
      selectedIngredient: null, // bound to the selected value
      headers: [
        { text: "Name", value: "name" },
        // {
        //   text: "Unit",
        //   sortable: true,
        //   value: "unit",
        // },
        { text: "Stock Quantity", value: "stock_quantity" },
      ],
      branchIngredientList: [],
      ingredientList: [],
      ingredientCompanyLinkBranchID: "",
      saveBtnLoading: false,
      singleBtnLoading: false,
      multiBtnLoading: false,
      dialog: false,
      title: "",
      selectBranch: "",
      cardLoading: true,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dialogDelete: false,
      search: "",
      selected: [],
      selectedBranchIngredient: [],
      branchID: "",
    };
  },

  watch: {
    selectBranch() {
      this.getAllBranchIngredient();
    },
    selectedIngredient() {
      if (this.title == "Add") {
        this.getBranchIngredient();
      }
    },
  },

  computed: {
    selectedIngredientErrors() {
      const errors = [];
      if (!this.$v.selectedIngredient.$dirty) return errors;
      !this.$v.selectedIngredient.required &&
        errors.push("Please select an ingredient!");
      return errors;
    },
  },

  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getCompanyBranch();
    this.getAllIngredient();
  },

  methods: {
    getAllIngredient() {
      const params = new URLSearchParams();
      params.append("getAllIngredient", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.ingredientList = response.data.ingredient;
            this.cardLoading = false;
          } else {
            this.ingredientList = [];
            this.cardLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAllBranchIngredient() {
      const params = new URLSearchParams();
      params.append("getAllBranchIngredient", "done");
      params.append("branch_id", this.selectBranch);

      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.branchIngredientList = response.data.ingredient;
            this.cardLoading = false;
          } else {
            this.branchIngredientList = [];
            this.cardLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getBranchIngredient() {
      this.selectedBranchIngredient = [];
      this.branchIngredient = [];
      const params = new URLSearchParams();
      params.append("getBranchIngredient", "done");
      params.append("ingredient_company_id", this.selectedIngredient);
      axios({
        method: "post",
        url: this.domain + "/ingredient/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var ingredientList = response.data.ingredient;
            // Step 1: push selected entries
            ingredientList.forEach((branch) => {
              const obj = {
                id: branch.branch_id,
                name: branch.branch_name,
                stock: branch.stock_quantity,
              };
              this.selectedBranchIngredient.push(obj);
              this.branchIngredient.push(obj);
            });
            // Step 2: push defaults only for branches not already added
            const existingIds = new Set(
              this.branchIngredient.map((b) => String(b.id))
            );

            this.branchList.forEach((branch) => {
              if (!existingIds.has(String(branch.branch_id))) {
                this.branchIngredient.push({
                  id: branch.branch_id,
                  name: branch.name,
                  stock: null,
                });
              }
            });
          } else {
            this.selectedBranchIngredient = [];
            this.branchList.forEach((branch) => {
              this.branchIngredient.push({
                id: branch.branch_id,
                name: branch.name,
                stock: null,
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    openDialog() {
      if (this.title == "Add") {
        this.$v.$reset();
        (this.selectedIngredient = null), (this.branchIngredient = []);
        this.selectedBranchIngredient = [];
        this.dialog = true;
      } else {
        this.$v.$reset();
        this.dialog = true;
      }
    },
    setToEmpty() {
      (this.selectedIngredient = null), (this.branchIngredient = []);
      this.selectedBranchIngredient = [];
    },

    handleClick(item) {
      this.setToEmpty();
      this.selectedIngredient = parseInt(item.ingredient_company_id);
      this.ingredientCompanyLinkBranchID =
        item.ingredient_company_link_branch_id;
      this.branchID = item.branch_id;
      this.branchIngredient.push({
        id: item.branch_id,
        name: item.name,
        stock: item.stock_quantity,
      });
      this.selectedBranchIngredient.push({
        id: item.branch_id,
        name: item.name,
        stock: item.stock_quantity,
      });
      this.title = "Edit";
      this.openDialog();
    },

    deleteIngredient() {
      if (this.selected != "") {
        this.multiBtnLoading = true;
        const array = [];
        for (let i = 0; i < this.selected.length; i++) {
          array.push(this.selected[i].ingredient_company_link_branch_id);
        }
        const params = new URLSearchParams();
        params.append("deleteMultiIngredientLinkBranchAndMovement", "done");
        params.append(
          "array_ingredient_company_link_branch_id",
          JSON.stringify(array)
        );
        params.append("branch_id", this.selected[0]["branch_id"]);
        axios({
          method: "post",
          url: this.domain + "/ingredient/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.dialog = false;
              this.multiBtnLoading = false;
              this.text = "Successfully delete";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.selected = [];
              this.dialogDelete = false;
              this.getAllBranchIngredient();
              this.sendNoticationForSpecificBranch(
                this.selected[0]["branch_id"]
              );
            } else {
              this.text = "Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.singleBtnLoading = true;
        const params = new URLSearchParams();
        params.append("deleteIngredientLinkBranchAndMovement", "done");
        params.append(
          "ingredientCompanyLinkBranchID",
          this.ingredientCompanyLinkBranchID
        );
        params.append("branch_id", this.branchID);
        axios({
          method: "post",
          url: this.domain + "/ingredient/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.singleBtnLoading = false;
              this.dialog = false;
              this.text = "Successfully delete";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.dialogDelete = false;
              this.getAllBranchIngredient();
              this.sendNoticationForSpecificBranch(this.branchID);
            } else {
              this.singleBtnLoading = false;
              this.text = "Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    isSelected(id) {
      return this.selectedBranchIngredient.some(
        (selected) => selected.id === id
      );
    },
    getCompanyBranch() {
      const params = new URLSearchParams();
      params.append("getCompanyBranch", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.branchList = response.data.branch;
            this.selectBranch = this.branchList[0].branch_id;
          } else {
            console.log("no list get");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    isRowSelected(item) {
      return this.selectedBranchIngredient.some(
        (selected) => selected.id === item.id
      );
    },

    sendNotication() {
      for (let i = 0; i < this.branchList.length; i++) {
        const params = new URLSearchParams();
        params.append("send_notification", "done");
        params.append("branch_id", this.branchList[i].branch_id);
        params.append("type", "1");

        axios({
          method: "post",
          url: this.syncDomain + "/sync/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              console.log("Send Notification successfully");
            } else {
              console.log("Send Notification fail");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    sendNoticationForSpecificBranch(branch_id) {
      const params = new URLSearchParams();
      params.append("send_notification", "done");
      params.append("branch_id", branch_id);
      params.append("type", "1");

      axios({
        method: "post",
        url: this.syncDomain + "/sync/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log("Send Notification successfully");
          } else {
            console.log("Send Notification fail");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    dialogAction() {
      this.saveBtnLoading = true;
      if (this.title == "Add") {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          const params = new URLSearchParams();
          params.append("assignIngredient", "done");
          params.append("company_id", this.companyID);
          params.append(
            "selectedBranchIngredient",
            JSON.stringify(this.selectedBranchIngredient)
          );
          params.append("selectedIngredient", this.selectedIngredient);
          axios({
            method: "post",
            url: this.domain + "/ingredient/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);
              if (response.data.status == "1") {
                this.dialog = false;
                this.text = "Successfully add";
                this.snackbar = true;
                this.snackbarColor = "success";
                this.saveBtnLoading = false;
                this.getAllBranchIngredient();
                this.sendNotication();
              } else {
                this.text = "Please try again later";
                this.snackbar = true;
                this.snackbarColor = "error";
                this.saveBtnLoading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }else{
          this.saveBtnLoading = false;
        }
      } else {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.selectedBranchIngredient = this.branchIngredient;
          const params = new URLSearchParams();
          params.append("editAssignIngredient", "done");
          params.append("company_id", this.companyID);
          params.append(
            "selectedBranchIngredient",
            JSON.stringify(this.selectedBranchIngredient)
          );
          params.append("selectedIngredient", this.selectedIngredient);
          axios({
            method: "post",
            url: this.domain + "/ingredient/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);
              if (response.data.status == "1") {
                this.dialog = false;
                this.text = "Successfully edit";
                this.snackbar = true;
                this.snackbarColor = "success";
                this.saveBtnLoading = false;
                this.getAllBranchIngredient();
                this.sendNoticationForSpecificBranch(this.branchID);
              } else {
                this.text = "Please try again later";
                this.snackbar = true;
                this.snackbarColor = "error";
                this.saveBtnLoading = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }else{
          this.saveBtnLoading = false;
        }
      }
    },
  },
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.stock-cell {
  display: flex;
  align-items: center; /* vertically center */
  justify-content: center;
  min-width: 150px; /* keeps column width stable */
}

.stock-field {
  margin: 0; /* remove extra margin */
  padding: 0;
  height: 36px; /* match row height */
}
</style>